"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRenderProperty = exports.NON_RENDERABLE_INPUTTYPES = exports.NON_RENDERABLE_DISPLAYTYPES = void 0;
exports.NON_RENDERABLE_DISPLAYTYPES = [
    'hidden',
    'notification',
    'title',
    'markdown',
];
exports.NON_RENDERABLE_INPUTTYPES = [
    'output',
    'time',
    'checkboxes',
    'subform',
]; // "time" will be rendered as hours in one section, and minutes in another
/**
 * Determines if a property should be rendered based on its displaytype, inputtype, and localization
 * @param {Object} propertySchema The schema for this property
 * @returns {boolean} True if should be rendered, false otherwise.
 */
function shouldRenderProperty(propertySchema) {
    const displayType = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.displayType;
    const inputType = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.inputType;
    const value_localization = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.value_localization;
    const nonRenderableDisplay = displayType && exports.NON_RENDERABLE_DISPLAYTYPES.includes(displayType);
    const nonRenderableInput = inputType && exports.NON_RENDERABLE_INPUTTYPES.includes(inputType);
    return (!nonRenderableDisplay &&
        !nonRenderableInput &&
        (!!value_localization || !!inputType));
}
exports.shouldRenderProperty = shouldRenderProperty;
//# sourceMappingURL=shouldRenderProperty.js.map